import React from 'react';

export const money = (n) =>
  `$${Math.round(n).toLocaleString('en-US')}`;

export const Progress = ({ step, total }) => (
  <div className="ik-progress" data-testid="intake-progress">
    {Array.from({ length: total }, (_, i) => (
      <div
        key={i}
        className={`ik-progress-step ${i < step ? 'is-done' : i === step ? 'is-active' : ''}`}
      />
    ))}
  </div>
);

export const ChoiceList = ({ options, value, onChange, testPrefix }) => (
  <div className="ik-choices" role="radiogroup">
    {options.map((o) => (
      <button
        key={o.value ?? o.key}
        type="button"
        role="radio"
        aria-checked={value === (o.value ?? o.key)}
        className={`ik-choice ${value === (o.value ?? o.key) ? 'is-selected' : ''}`}
        onClick={() => onChange(o.value ?? o.key)}
        data-testid={`${testPrefix}-${o.value ?? o.key}`}
      >
        <span className="ik-choice-dot" />
        <span className="ik-choice-body">
          {o.label}
          {o.note ? <span className="ik-choice-note">{o.note}</span> : null}
        </span>
      </button>
    ))}
  </div>
);

export const ShockTable = ({ shock }) => (
  <div className="ik-shock" data-testid="intake-shock-table">
    <div className="ik-shock-from">
      Starting from <strong>{money(shock.allocation)}</strong>
    </div>
    <div className="ik-shock-head">
      <div className="ik-shock-cell">
        <div className="ik-shock-key">Historical worst · −{shock.historical.pct}%</div>
      </div>
      <div className="ik-shock-cell">
        <div className="ik-shock-key">Planning case · −{shock.planning.pct}%</div>
      </div>
    </div>
    <div className="ik-shock-row">
      <div className="ik-shock-cell">
        <div className="ik-shock-val" data-testid="intake-shock-historical">
          {money(shock.historical.value)}
        </div>
        <div className="ik-shock-loss">−{money(shock.historical.loss)}</div>
      </div>
      <div className="ik-shock-cell ik-shock-plan">
        <div className="ik-shock-val" data-testid="intake-shock-planning">
          {money(shock.planning.value)}
        </div>
        <div className="ik-shock-loss">−{money(shock.planning.loss)}</div>
      </div>
    </div>
  </div>
);

export const TierLadder = ({ tiers, current }) => (
  <div className="ik-tier-list" data-testid="intake-tier-ladder">
    {tiers.map((t) => (
      <div
        key={t.tier}
        className={`ik-tier-row ${t.tier === current ? 'is-you' : ''}`}
        data-testid={`intake-tier-row-${t.tier}`}
      >
        <span className="ik-tier-row-num">TIER {t.tier}</span>
        <span>{t.name}</span>
        <span className="ik-tier-row-ratio">{t.core} / {t.explore}</span>
      </div>
    ))}
  </div>
);
